import { isBrowserOnlyPathname } from '@maximizer/oauth2/data-access';
import {
  SYNC_CONFIG_LANG_PARAM,
  SYNC_CONFIG_LANG_STORAGE_KEY,
} from '@maximizer/outlook/shared/data-access';

const SUPPORTED_LOCALES = ['en', 'fr'];
const DEFAULT_LOCALE = 'en';

export function getOfficeContextSafe(): Office.Context | undefined {
  try {
    return Office?.context;
  } catch (error) {
    console.warn('Office context access error', error);
    return undefined;
  }
}

function toSupportedLocale(language: string | null | undefined): string | null {
  const code = language?.toLowerCase().split('-')[0] ?? '';
  return SUPPORTED_LOCALES.includes(code) ? code : null;
}

function getRequestedLanguage(): string | null {
  try {
    if (!isBrowserOnlyPathname(globalThis.location.pathname)) return null;

    const fromUrl = toSupportedLocale(
      new URLSearchParams(globalThis.location.search).get(
        SYNC_CONFIG_LANG_PARAM,
      ),
    );
    if (fromUrl) {
      try {
        if (sessionStorage.getItem(SYNC_CONFIG_LANG_STORAGE_KEY) !== fromUrl) {
          sessionStorage.setItem(SYNC_CONFIG_LANG_STORAGE_KEY, fromUrl);
        }
      } catch (error) {
        console.warn('Requested language persistence error', error);
      }
      return fromUrl;
    }
    return toSupportedLocale(
      sessionStorage.getItem(SYNC_CONFIG_LANG_STORAGE_KEY),
    );
  } catch (error) {
    console.warn('Requested language access error', error);
    return null;
  }
}

export function getOfficeLocale(): string {
  const requestedLanguage = getRequestedLanguage();
  if (requestedLanguage) return requestedLanguage;

  const detectedLanguage =
    getOfficeContextSafe()?.displayLanguage ??
    navigator.language ??
    navigator.languages?.[0];

  return toSupportedLocale(detectedLanguage) ?? DEFAULT_LOCALE;
}

export function isOfficeFrench(): boolean {
  return getOfficeLocale() === 'fr';
}
